<template>
  <div>
    <a class="btn btn-sm btn-primary" role="button" data-toggle="collapse" href="#collapseAddUser" aria-expanded="false" aria-controls="collapseAddUser">
        <i class="fa fa-plus"></i> Add Booking Agent
    </a>

    <div class="collapse" id="collapseAddUser">
      <div class="margin-20"></div>

      <form>
        <div class="panel panel-grey no-margin">
          <div class="panel-body">
            <div class="form-horizontal">
              <create-user ref="createUser" />
              <div class="alert alert-info m-b-none">
                We'll send an e-mail to the new booking agent where they will be able to set their password.
              </div>
            </div>
          </div>
          <div class="panel-footer text-right">
            <ladda-button
              type="submit"
              class="btn btn-sm btn-info"
              :click="handleAddUserCallback">
              Add Booking Agent
            </ladda-button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { notify } from 'utils'
import CreateUser from '../CreateUser'

export default {
  components: {
    CreateUser
  },

  computed: {
    ...mapState('user', ['user'])
  },

  methods: {
    ...mapActions('manager/staff', [
      'storeManagerStaffUser'
    ]),

    handleAddUserCallback () {
      if (this.$refs.createUser.invalid) {
        this.$refs.createUser.validate()
        notify.error('Some fields are invalid. Please check and try again.')
        return Promise.resolve()
      }

      const payload = this.$refs.createUser.payload

      return this.storeManagerStaffUser({ id: this.user.id, payload })
        .then((response) => {
          this.$refs.createUser.reset()
        })
        .catch(() => {
          notify.error('Something went wrong. Please check your input and try again.')
        })
    }
  }
}
</script>
